import { toCurrency } from "components-library";
import { useCurrency } from "@store/actions/customActions";
import Breadcrumb from "@components/breadcrumb/Breadcrumb";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import { useRoutesContext } from "@providers/RoutesProvider";
import { useGetQuoteUserStats } from "@store/actions/quoteActions";
import { useGetAllUser } from "@store/actions/userActions";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { friendlyDateTime } from "utils/date";
import { formatNumber } from "utils/numbers";

function UserPage() {
  const { userId } = useParams();
  const { data, loading, error } = useGetQuoteUserStats(userId);
  const { loading: allUserLoading, data: allUserData, error: allUserError } = useGetAllUser();
  const { data: currencyData, loading: currencyLoading, error: currencyError } = useCurrency();
  const { routes } = useRoutesContext();

  const user = useMemo(() => {
    if (!allUserData) {
      return;
    }
    return allUserData.users.find((u) => u.id === userId);
  }, [allUserData, userId]);

  if (loading || allUserLoading || currencyLoading) {
    return <CircularProgress />;
  }
  if (error || allUserError || currencyError || !currencyData?.currency || !data?.quoteStats) return <Typography>User statistics could not be loaded. Please try again.</Typography>;
  if (!user) return <Typography>This user could not be found.</Typography>;
  return (
    <>
      <Breadcrumb routes={routes} />
      <Divider />
      <br />

      <Grid container spacing={2} style={{ maxWidth: 1100 }}>
        <Grid item xs={12}>
          {allUserLoading ? (
            <CircularProgress />
          ) : (
            <>
              <Typography variant="h6">{user.email}</Typography>
              <Typography variant="body2">
                <strong>name : </strong> {user.firstName} {user.lastName}
              </Typography>
              <Typography variant="body2">
                <strong>user name : </strong> {user.userName}
              </Typography>
              <Typography variant="body2">
                <strong>last login : </strong>{" "}
                {friendlyDateTime(user.lastLogin)}
              </Typography>
            </>
          )}
          <Grid item xs={12}>
            <Box mt={2}>
              <Divider />
            </Box>
          </Grid>
        </Grid>
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            <Grid item xs={12}>
              <Typography variant="h6">Quote stats</Typography>
            </Grid>
            <Grid item xs={3}>
              <Card>
                <CardContent>
                  <Typography>No. of sent quotes.</Typography>
                  <Typography variant="h5">
                    {formatNumber(data.quoteStats.sentQuotes)}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={3}>
              <Card>
                <CardContent>
                  <Typography>No. of paid quotes.</Typography>
                  <Typography variant="h5">
                    {formatNumber(data.quoteStats.paidQuotes)}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={3}>
              <Card>
                <CardContent>
                  <Typography>Total Revenue.</Typography>
                  <Typography variant="h5">
                    {toCurrency(data.quoteStats.totalRevenue / 100, currencyData.currency)}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={3}>
              <Card>
                <CardContent>
                  <Typography>Average Revenue per quote.</Typography>
                  <Typography variant="h5">
                    {toCurrency(data.quoteStats.averageQuoteRevenue / 100, currencyData.currency)}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
}

export default UserPage;
